<template>
  <div style="text-align: center">
    <van-loading type="spinner"
                 size="100px" />
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  data() {
    return {
      faceNum: '',
      userName: localStorage.getItem('mobile'),
      password1: localStorage.getItem('password')
    }
  },
  methods: {
    // 获取百度人脸识别照片
    searchBaiduFace() {
      let param = {}
      param.access_token = this.$sessionStore.getAccessToken()
      param.verify_token = this.$sessionStore.getVerifyToken()
      this.$api.get('/user/searchBaiduFace', param, (res) => {
        if (res.code == 'SUCCESS') {
          const a = res.data
          this.livingThing(a)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //活体检测
    livingThing(pictures) {
      if (this.faceNum == 2) {
        let params = {}
        params.userId = localStorage.getItem('userId')
        params.realName = localStorage.getItem('realName')
        params.idCard = localStorage.getItem('idCard')
        params.imgURL = pictures
        this.$axiosPackag.getMessageByAxios(
          'POST',
          '/user/faceCollect',
          params,
          null,
          null,
          (resD) => {
            if (resD) {
              this.$axiosPackag.getMessageByAxios(
                'POST',
                '/user/h5login',
                {
                  userName: this.userName,
                  password1: this.password1
                },
                null,
                null,
                (resD) => {
                  if (resD) {
                    localStorage.setItem('loginUrl', resD)
                    Toast('登录成功')
                    this.$axiosPackag.getMessageByAxios(
                      'GET',
                      '/session/getSession',
                      null,
                      null,
                      null,
                      (resD) => {
                        if (resD) {
                          this.$sessionStore.initSession(resD)
                          this.$router.push({ path: '/mobileHome' })
                        }
                      }
                    )
                  }
                },
                (errorCall) => {}
              )
            }
          }
        )
      } else if (this.faceNum == 5) {
        let params = {}
        params.userId = localStorage.getItem('userId')
        params.realName = localStorage.getItem('realName')
        params.idCard = localStorage.getItem('idCard')
        params.imgURL = pictures
        this.$axiosPackag.getMessageByAxios(
          'POST',
          '/user/faceCollect',
          params,
          null,
          null,
          (resD) => {
            if (resD) {
              this.$axiosPackag.getMessageByAxios(
                'POST',
                '/user/h5login',
                {
                  userName: this.userName,
                  password1: this.password1
                },
                null,
                null,
                (resD) => {
                  if (resD) {
                    localStorage.setItem('loginUrl', resD)
                    Toast('登录成功')
                    this.$axiosPackag.getMessageByAxios(
                      'GET',
                      '/session/getSession',
                      null,
                      null,
                      null,
                      (resD) => {
                        if (resD) {
                          this.$sessionStore.initSession(resD)
                          this.$router.push({ path: '/mobileHome' })
                        }
                      }
                    )
                  }
                },
                (errorCall) => {}
              )
            }
          }
        )
      } else if (this.faceNum == 3) {
        let params = {}
        params.userId = localStorage.getItem('userId')
        params.imgURL = pictures
        this.$axiosPackag.getMessageByAxios(
          'POST',
          '/user/faceVerify',
          params,
          null,
          null,
          (resD) => {
            if (resD) {
              this.$axiosPackag.getMessageByAxios(
                'POST',
                '/user/h5login',
                {
                  userName: this.userName,
                  password1: this.password1
                },
                null,
                null,
                (resD) => {
                  if (resD) {
                    localStorage.setItem('loginUrl', resD)
                    Toast('登录成功')
                    this.$axiosPackag.getMessageByAxios(
                      'GET',
                      '/session/getSession',
                      null,
                      null,
                      null,
                      (resD) => {
                        if (resD) {
                          this.$sessionStore.initSession(resD)
                          this.$router.push({ path: '/mobileHome' })
                        }
                      }
                    )
                  }
                },
                (errorCall) => {}
              )
            }
          }
        )
      } else if (this.faceNum == 4) {
        let params = {}
        params.userId = localStorage.getItem('userId')
        params.imgURL = pictures
        this.$axiosPackag.getMessageByAxios(
          'POST',
          '/user/faceVerify',
          params,
          null,
          null,
          (resD) => {
            if (resD) {
              this.$axiosPackag.getMessageByAxios(
                'POST',
                '/user/h5login',
                {
                  userName: this.userName,
                  password1: this.password1
                },
                null,
                null,
                (resD) => {
                  if (resD) {
                    localStorage.setItem('loginUrl', resD)
                    Toast('登录成功')
                    this.$axiosPackag.getMessageByAxios(
                      'GET',
                      '/session/getSession',
                      null,
                      null,
                      null,
                      (resD) => {
                        if (resD) {
                          this.$sessionStore.initSession(resD)
                          this.$router.push({ path: '/mobileHome' })
                        }
                      }
                    )
                  }
                },
                (errorCall) => {}
              )
            }
          }
        )
      }
    }
  },
  created() {
    this.searchBaiduFace()
    let geturl = window.location.href
    let getqyinfo = geturl.split('?')[1]
    let getqys = getqyinfo.split('&')
    let getqycode = getqys[0].split('=')[1]
    this.faceNum = getqycode
  }
}
</script>
<style>
.mobileFaceVerification .van-overlay {
  background-color: rgb(0 0 0) !important;
}
</style>
<style scoped>
.faceintroduce {
  margin-left: 0.426667rem;
  margin-top: 0.32rem;
  color: #555555;
  font-weight: 400;
  font-size: 0.373333rem;
}
.facepic img {
  width: 6.613333rem;
  height: 6.613333rem;
}
.facepic {
  display: flex;
  justify-content: space-around;
  margin-bottom: 0.8rem;
  margin-top: 0.64rem;
}
.faceTitle {
  margin-top: 0.64rem;
  text-align: center;
  font-size: 0.426667rem;
}
.van-button {
  width: 9.146667rem;
  height: 1.28rem;
  border-radius: 0.64rem;
}
.startPic {
  text-align: center;
}
.standard {
  text-align: center;
  margin-top: 0.533333rem;
}
.van-popup img {
  width: 6.64rem;
  height: 7.333333rem;
}
.van-popup .van-button {
  color: #ffffff;
  border: 0.026667rem solid #ffffff;
  border-radius: 0.106667rem;
  background: none;
  margin-top: 0.64rem;
  width: 6.64rem;
  height: 1.28rem;
}
.standardPic {
  background: none;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.standardPic-title {
  color: #ffffff;
  font-size: 0.453333rem;
  text-align: center;
  margin-bottom: 0.64rem;
}
.van-popup--center {
  top: 35%;
}
</style>


// WEBPACK FOOTER //
// index.vue?0cd790f0